import { createSelector } from 'reselect';
import {
    handleRehydrateAction,
    handleRemoveAction,
    handleSubmitAction
} from '../../../core/store/helpers/reducer-helper';
import * as jobActions from '../job/job.actions';
import * as fromNoteActions from './note.actions';
import { Note } from './note.model';

export interface State {
    ids: Array<string>;
    entities: { [id: string]: Note };
}

export const initialState: State = {
    ids: [],
    entities: {}
};

// tslint:disable-next-line:only-arrow-functions
export function reducer(
    state = initialState,
    action: fromNoteActions.Actions | jobActions.Actions
): State {
    switch (action.type) {
        case fromNoteActions.SUBMIT: {
            return handleSubmitAction(state, action);
        }
        case fromNoteActions.REHYDRATE: {
            return handleRehydrateAction(state, action);
        }
        case fromNoteActions.REMOVE: {
            return handleRemoveAction(state, action);
        }
        case jobActions.WIPE: {
            return {
                ...state,
                ids: [],
                entities: {}
            };
        }
        default: {
            return state;
        }
    }
}

/**
 * Because the data structure is defined within the reducer it is optimal to
 * locate our selector functions at this level. If store is to be thought of
 * as a database, and reducers the tables, selectors can be considered the
 * queries into said database. Remember to keep your selectors small and
 * focused so they can be combined and composed to fit each particular
 * use-case.
 */

export const getEntities = (state: State) => state.entities;

export const getIds = (state: State) => state.ids;

export const getAll = createSelector(getEntities, getIds, (entities, ids) => ids.map(id => entities[id]));



// WEBPACK FOOTER //
// ./src/vas/business-objects/note/note.reducer.ts